module.exports = __webpack_public_path__ + "img/gift4.f3a20dcf.png";